module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiVideoItem/asset/arrow.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiVideoItem/asset/arrow.png
// module id = 656
// module chunks = 367